import React, { useContext } from 'react';
import { Button } from '@mui/material';
import { SVGS } from '@zonofi/zono-money-design-system';
import './survey-form-screen.scss';
import { useAppSelector } from '@zonofi/zono-money-helpers';
import { getCustomerInvite } from '@zonofi/zono-money-store';
import { onClickBackToWhatsapp } from '@zonofi/zono-money-whatsapp-stack';

export const SurveySuccessful: React.FC = () => {
  const inviteDetails = useAppSelector(getCustomerInvite);
  const { seller, waConfig } = inviteDetails;

  return (
    <div className="survey-successful">
      <div className="icon">
        <img className="svg-icon" height={120} src={SVGS.OrderSuccess} />
      </div>
      <div className="content">
        <h4 className="font-primary-semibold">
          Response submitted successfully!
        </h4>
      </div>
      <div className="btn_section">
        <Button
          disableRipple
          disableFocusRipple
          disableElevation
          sx={{ all: 'unset' }}
          className="backto_whatsapp"
          onClick={() =>
            onClickBackToWhatsapp({
              whatsappPhoneNo: waConfig?.whatsappPhoneNo,
              workspaceId: seller?.workspaceId,
            })
          }
        >
          Back to WhatsApp
        </Button>
      </div>
    </div>
  );
};
